import './SearchSelect.css';

import { TextField, Tooltip } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import sortBy from 'lodash/sortBy';
import React, { useEffect, useMemo, useState } from 'react';

import { Choice } from './SearchSelectTypes';

export interface SearchSelectProps {
  onChange: (value: string) => void;
  value?: string;
  choices: Array<Choice>;
  leftLabel?: string;
  helperText?: string;
  placeHolder?: string;
}

const SearchSelect: React.FC<SearchSelectProps> = (props) => {
  const {
    onChange,
    value,
    choices,
    leftLabel,
    helperText,
    placeHolder
  } = props;

  const [selectedValue, setSelectedValue] = useState(value || '');

  // Sync internal state with prop changes
  useEffect(() => {
    setSelectedValue(value || '');
  }, [value]);

  const sortedChoices = useMemo(() => {
    return sortBy(choices, ['text']);
  }, [choices]);

  const selectedChoice = useMemo(() => {
    if (selectedValue) {
      const choice = sortedChoices.find((c) => c.value === selectedValue);
      return choice || null;
    }
    return null;
  }, [selectedValue, sortedChoices]);

  return (
    <div
      className="input-field-container SearchSelect"
      data-testid="SearchSelect"
    >
      <div className="mb-2 md:mb-4">
        {leftLabel || ''}
        {helperText ? (
          <Tooltip
            title={helperText}
            arrow
            classes={{
              arrow: 'text-tertiary',
              tooltip: 'text-sm bg-tertiary'
            }}
            enterTouchDelay={1}
          >
            <div className="help-button">?</div>
          </Tooltip>
        ) : null}
      </div>
      <Autocomplete
        id="searchselect"
        options={sortedChoices}
        getOptionLabel={(choice) => choice.text}
        value={selectedChoice}
        popupIcon={<ExpandMore data-testid="ExpandMoreIcon" />}
        onChange={(e, newValue) => {
          if (newValue) {
            setSelectedValue(newValue.value);
            onChange(newValue.value);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={!selectedChoice ? placeHolder : undefined}
            variant="outlined"
          />
        )}
      />
    </div>
  );
};

export default SearchSelect;
